import type { RootState } from "@store/store";
import { resolvePortalRole, type PortalRole } from "@constants/portalRoles";

export function selectPortalRole(state: RootState): PortalRole {
	const u = state.user.user;
	if (!u) return resolvePortalRole(undefined, []);
	return resolvePortalRole(u.emailAddress, u.roles ?? []);
}
